module.exports = __webpack_public_path__ + "img/g-press.9ddaa974.png";